import * as React from "react";
import { Spin, Layout, Row, Col, Space, Typography } from "antd";
import LegalViewList from "../../../legalViews/ui/components/LegalViewList";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import SearchCriteriaForm from "../../../search/ui/components/SearchCriteriaForm";
import { ILegalViewsPresenter } from "../../presenter/LegalViewsPresenter";
const { Content, Sider } = Layout;
const { Title } = Typography;
export interface Props extends PageProps {}
export interface State extends ILegalViewsPresenter {}

export default class LegalViewPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      legalViews,
      organisations,
      store,
      loaders,
      createNewLegalView,
      showLegalViewDetails,
      user,
      application
    } = this.state;
    return (
      <Page {...this.props}>
        {
          <Spin spinning={this.state.loaders.legalViewLoader}>
            <Layout>
              <Sider
                className={"content-container dashboard-sider search-sider"}
                breakpoint="xl"
                collapsible
                collapsedWidth="0"
                width={"22%"}
              >
                <SearchCriteriaForm
                  translate={translate}
                  organisations={organisations}
                  showStatusFilter={!application.isPortal()}
                  user={user}
                />
              </Sider>
              <Layout className={"dashboard-content-wrapper"}>
                <Content className="site-layout-background dashboard-content-container">
                  <Row gutter={[0, 16]}>
                    <Col xs={24} sm={24}>
                      <Space size={"large"} align="center">
                        <Title level={1}>
                          {translate("editors.legal_views.title")}
                        </Title>
                      </Space>
                    </Col>
                  </Row>
                  <LegalViewList
                    translate={translate}
                    store={store}
                    loaders={loaders}
                    legalViewList={legalViews}
                    createNewLegalView={createNewLegalView}
                    showLegalViewDetails={showLegalViewDetails}
                    user={user}
                  />
                </Content>
              </Layout>
            </Layout>
          </Spin>
        }
      </Page>
    );
  }
}
